import React from 'react';
import { createPortal } from 'react-dom';

const PromoConfirmModal = ({
  open,
  title,
  subtitle,
  items = [],
  error,
  submitting,
  onCancel,
  onConfirm,
  cancelLabel,
  confirmLabel,
  titleId = 'promo-confirm-title',
}) => {
  if (!open) return null;

  // Портал в <body>: иначе backdrop с position:fixed «ловится» предком
  // .main-content (contain: layout) и затемняет лишь область ниже навбара.
  return createPortal(
    <div className="admin-modal-backdrop" onClick={onCancel} role="presentation">
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 id={titleId} className="admin-promo-confirm-title">
            {title}
          </h3>
        </div>
        <div className="modal-body admin-promo-confirm-body">
          {subtitle && <p className="admin-promo-confirm-subtitle">{subtitle}</p>}
          {items.length > 0 && (
            <ul className="confirm-list">
              {items.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}:</strong> {item.value ?? '—'}
                </li>
              ))}
            </ul>
          )}
          {error && (
            <div className="form-status error" role="alert">
              {error}
            </div>
          )}
        </div>
        <div className="modal-actions admin-modal-actions">
          <button
            type="button"
            className="btn btn-secondary admin-modal-btn-cancel"
            onClick={onCancel}
            disabled={submitting}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn btn-primary admin-modal-btn-submit"
            onClick={onConfirm}
            disabled={submitting}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PromoConfirmModal;
